// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__7y97f","alertIcon":"ConfirmModal_alertIcon__2znve"};